import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { NewLandLevelingVM } from './NewLandLevelingVM';
import stores from '../../../models/Stores';
import './newLandLeveling.scss';
import { EsriWidgetHost } from 'cd-eft/components/common/mapping';
import { toDecimalPrecision } from 'cd-eft/utils/mathUtilities';
import { UserLeavingWarning } from 'cd-eft/components/common/UserLeavingWarning/UserLeavingWarning';
import { InformationTooltip } from 'cd-eft/components/common/InformationTooltip/InformationTooltip';

const { landLevelingDesignStore, designStore } = stores.AppStore;

const NewLandLevelingComponent = (props) => {
  const history = useHistory();
  const vmRef = useRef<NewLandLevelingVM>();
  if (vmRef.current === undefined) vmRef.current = new NewLandLevelingVM(props);
  const vm = vmRef.current;

  useEffect(() => {
    vm.getErrors();
    vm.onMount(history);

    function cleanup() {
      vm.onUnmount();
    }
    return cleanup;
  }, []);

  return (
    <div className="structure-new-land-leveling-form">
      {/* popups  */}
      {(stores.AppStore.designStore.hasProject()) && (landLevelingDesignStore.pendingEdits.design || landLevelingDesignStore.pendingEdits.unsavedEdits || landLevelingDesignStore.pendingEdits.name) && (
        <UserLeavingWarning
          when={stores.AppStore.designStore.hasProject() && (landLevelingDesignStore.pendingEdits.design || landLevelingDesignStore.pendingEdits.unsavedEdits || landLevelingDesignStore.pendingEdits.name)}
          section="Land Leveling Design"
          onOK={vm.userLeavingWarningOnOk}
          okText="Return"
          text={
            vm.notification.openLandLeveling
          }
        />
      )}
      <div className="row land-leveling-name">
        <input
          name="name"
          id="name"
          aria-required="true"
          aria-label="Land Leveling Name"
          value={vm.newLandLevelingForm.name}
          onChange={(e) => vm.handleInputChange(e)}
          className={'mr-2' + vm.errorClass('name')}
          placeholder="Land Leveling Name..."
        />
      </div>

      {/* Errors, Equal Cut/Fill SLopes and Pick Up Center Button */}
      <span className="usa-error-message" id="new-landLeveling-error--message" role="alert">
        <div>{vm.formValidation.formErrors['name']}</div>
        <div>{vm.errorMsg}</div>
      </span>
      <fieldset disabled={!designStore.hasProject() || !designStore.hasSurfaceTest()}>
        <label className="usa-label row-label" htmlFor="field-boundary-div">
          Define Field Boundary
        </label>
        <div className="row field-boundary-div" id="field-boundary-div">
          <div className="col-md-4 pr-0 cursor-pointer"
            onMouseEnter={vm.onMouseEnter}
            onMouseLeave={vm.onMouseLeave}
          >
            <button
              className="usa-button"
              disabled={designStore.currentSurface.surfaceDefClassId === 2}
              onClick={() => {
                if (designStore.currentSurface.surfaceDefClassId !== 2) {
                  vm.toggleWholeField(props.mapView);
                }
              }}
            >
              Whole Field
            </button>
            {vm.isHovered && designStore.currentSurface.surfaceDefClassId === 2 && (
              <div className="hover-text-Button">{vm.errorMessage}</div>
            )}
          </div>
          <div className="col-md-6">
            {/* <button
            className="usa-button"
            onClick={() => {
              vm.displaySketchWidget(props.mapView, props.sketchWidget);
            }}
          >
            Draw a Boundary
          </button> */}
            Draw a Boundary
            <div>
              <EsriWidgetHost esriWidget={vm.sketchWidget}></EsriWidgetHost>
            </div>
          </div>
          <span className="usa-error-message ml-3" id="new-landLeveling-error--message" role="alert">
            <div>{vm.formValidation.formErrors['boundaryPoints']}</div>
            <div>{vm.formValidation.formErrors['useWholeField']}</div>
            <div>{vm.errorMsg}</div>
          </span>
        </div>

        <label className="usa-label row-label" htmlFor="base-point-div">
          Base Point
        </label>
        <div className="row land-leveling-inputs" id="base-point-div">
          <div className="col-md-4">
            <label className="usa-label" htmlFor="basePointx">
              X
            </label>
            <input
              className={'usa-input' + vm.errorClass('basePointx')}
              id="basePointx"
              aria-required="true"
              aria-label="Base Point X"
              name="basePointx"
              type="number"
              value={vm.newLandLevelingForm.basePoint.x}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>
          <div className="col-md-4">
            <label className="usa-label" htmlFor="basePointy">
              Y
            </label>

            <input
              className={'usa-input' + vm.errorClass('basePointy')}
              id="basePointy"
              aria-required="true"
              aria-label="Base Point Y"
              name="basePointy"
              type="number"
              value={vm.newLandLevelingForm.basePoint.y}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>
          <div className="col-md-4">
            <label className="usa-label " htmlFor="basePointz">
              Z
            </label>
            <input
              className={`usa-input ${vm.errorClass('basePointz')}`} // removed: ${vm.lockBasePointZ ? 'disabled ' : ''}
              id="basePointz"
              aria-required="true"
              aria-label="Base Point Z"
              name="basePointz"
              type="number"
              value={vm.newLandLevelingForm.basePoint.z}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            // disabled={vm.lockBasePointZ}
            />

            {/* <input
              className="usa-checkbox__input"
              data-behavior="select-table-row"
              id="basePointZcheckBox"
              aria-label="Use Base Point Z"
              type="checkbox"
              name="basePointZcheckBox"
              value="basePointZcheckBox"
              checked={vm.lockBasePointZ}
              onChange={vm.toggleLockBasePointZ}
            />

            <label className="usa-checkbox__label base-point-checkbox" htmlFor="basePointZcheckBox">
              Lock Z
            </label> */}
          </div>
        </div>
        <span className="usa-error-message" id="new-landLeveling-error--message" role="alert">
          <div>{vm.formValidation.formErrors['basePointx']}</div>
          <div>{vm.formValidation.formErrors['basePointy']}</div>
          <div>{vm.formValidation.formErrors['basePointz']}</div>
        </span>
        <div className="row">
          <div className="col-md-4 pr-0">
            <button className="usa-button" onClick={vm.postGetCentroid}>
              Centroid
            </button>
          </div>
          <div className="col-sm-8 pick-up-center-button">
            <span>Pick Base Point</span>
            <div hidden={!stores.AppStore.designStore.sceneViewActive}> - only available on 2D view - </div>
            <div hidden={stores.AppStore.designStore.sceneViewActive}>
              <EsriWidgetHost esriWidget={vm.bpSketchWidget}></EsriWidgetHost>
            </div>
          </div>
        </div>
        <label className="usa-label row-label" htmlFor="base-point-div">
          Percent Slopes
        </label>
        <div className="row land-leveling-inputs slopes" id="base-point-div">
          <div className="col-md-4">
            <label className="usa-label" htmlFor="xslope">
              Sx
            </label>
            <input
              className={'usa-input' + vm.errorClass('xslope')}
              id="xslope"
              aria-required="true"
              name="xslope"
              type="number"
              value={vm.newLandLevelingForm.xslope}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>
          <div className="col-md-4">
            <label className="usa-label" htmlFor="yslope">
              Sy
            </label>
            <input
              className={'usa-input' + vm.errorClass('yslope')}
              id="yslope"
              aria-required="true"
              name="yslope"
              type="number"
              value={vm.newLandLevelingForm.yslope}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>
          <div className="col-md-4">
            <button className="usa-button" onClick={vm.postGetBestFit}>
              Best Fit
            </button>
          </div>
        </div>
        <span className="usa-error-message" id="new-landLeveling-error--message" role="alert">
          <div>{vm.formValidation.formErrors['xslope']}</div>
          <div>{vm.formValidation.formErrors['yslope']}</div>
        </span>

        <div className="row land-leveling-inputs slopes" id="base-point-div">
          <div className="col-md-4">
            <label className="usa-label" htmlFor="borrow">
              Borrow
            </label>
            <input
              className={'usa-input' + vm.errorClass('borrow')}
              id="borrow"
              aria-required="true"
              name="borrow"
              type="number"
              value={vm.newLandLevelingForm.borrow}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>
          <div className="col-md-4">
            <label className="usa-label" htmlFor="waste">
              Waste
            </label>
            <input
              className={'usa-input' + vm.errorClass('waste')}
              id="waste"
              aria-required="true"
              name="waste"
              type="number"
              value={vm.newLandLevelingForm.waste}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>
          <div className="col-md-4">
            <label className="usa-label" htmlFor="cutFillRatio">
              Cut/Fill Ratio
            </label>
            <input
              className={'usa-input' + vm.errorClass('cutFillRatio')}
              id="cutFillRatio"
              aria-required="true"
              name="cutFillRatio"
              type="number"
              value={toDecimalPrecision(vm.newLandLevelingForm.cutFillRatio, 2)}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>
        </div>

        <span className="usa-error-message" id="new-landLeveling-error--message" role="alert">
          <div>{vm.formValidation.formErrors['borrow']}</div>
          <div>{vm.formValidation.formErrors['waste']}</div>
          <div>{vm.formValidation.formErrors['cutFillRatio']}</div>
        </span>

        <div className="row land-leveling-inputs slopes" id="base-point-div">
          <div className="col-md-4">
            <label className="usa-label row-label" htmlFor="llStakeoutGrid">
              Stakeout Grid
            </label>
            <label className="usa-label grid-label" htmlFor="llStakeoutGrid">
              Grid spacing (ft)
            </label>
            <input
              className={'usa-input' + vm.errorClass('llStakeoutGrid')}
              id="llStakeoutGrid"
              aria-required="true"
              name="llStakeoutGrid"
              type="number"
              value={vm.newLandLevelingForm.llStakeoutGrid}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
            />
          </div>

          <div className="col-md-4">
            <label className="usa-label row-label pr-3" htmlFor="bufferSize">
              <p className="buffer-label">Buffer</p>
              <InformationTooltip tooltipMessage={'The buffer establishes the transition zone between the land leveled surface and natural ground. Exterior to the land leveled surface.'} tooltipSide="bottom" id="ll-buffer-tooltip" extraClass='mt-0' />
            </label>
            <label className="usa-label" htmlFor="bufferSize">
              Width(ft)
            </label>
            <input
              className={'usa-input' + vm.errorClass('bufferSize')}
              id="bufferSize"
              aria-required="true"
              name="bufferSize"
              type="number"
              value={vm.newLandLevelingForm.bufferSize}
              onChange={vm.handleInputChange}
              onBlur={vm.handleOnBlurRounding}
              disabled={vm.newLandLevelingForm.useWholeField}
            />
          </div>
        </div>



        <div className="row">
          <span className="usa-error-message ml-3" id="new-landLeveling-error--message" role="alert">
            <div>{vm.formValidation.formErrors['llStakeoutGrid']}</div>
            <div>{vm.formValidation.formErrors['bufferSize']}</div>
          </span>
          <button
            className="usa-button design-button"
            onClick={vm.generateStructure}
            disabled={
              vm.isLoading ||
              (!landLevelingDesignStore.newDesign && landLevelingDesignStore.pendingEdits.name && !landLevelingDesignStore.pendingEdits.design) ||
              (landLevelingDesignStore.newDesign && !landLevelingDesignStore.pendingEdits.design)
            }>
            Design
          </button>
        </div>
      </fieldset>

      <div className="row">
        <div className="calculations-container">
          <h4>Land Level Calculations</h4>
          <div className="col-md-6">
            <div className="mb-1">
              Cut Volume (cy):{' '}
              {landLevelingDesignStore.newLandLevelingResults?.cutVolume
                ? toDecimalPrecision(landLevelingDesignStore.newLandLevelingResults?.cutVolume, 2)
                : '--'}
            </div>
            <div className="mb-1">
              Fill Volume (cy):{' '}
              {landLevelingDesignStore.newLandLevelingResults?.fillVolume
                ? toDecimalPrecision(landLevelingDesignStore.newLandLevelingResults?.fillVolume, 2)
                : '--'}{' '}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-1">
              Cut Rate:{' '}
              {landLevelingDesignStore.newLandLevelingResults?.cutRate
                ? toDecimalPrecision(landLevelingDesignStore.newLandLevelingResults?.cutRate, 2)
                : '--'}
            </div>
            <div className="mb-1">
              Field Area (acre):{' '}
              {landLevelingDesignStore.newLandLevelingResults?.fieldArea
                ? toDecimalPrecision(landLevelingDesignStore.newLandLevelingResults?.fieldArea, 2)
                : '--'}
            </div>
          </div>
        </div>

      </div>

      <div className="row">
        <div className="calculations-container">
          <h4>Buffer Calculations</h4>
          <div className="col-md-6">
            <div className="mb-1">
              Cut Volume (cy):{' '}
              {landLevelingDesignStore.newLandLevelingResults?.totalBufferCut
                ? toDecimalPrecision(landLevelingDesignStore.newLandLevelingResults?.totalBufferCut, 2)
                : '--'}
            </div>
            <div className="mb-1">
              Fill Volume (cy):{' '}
              {landLevelingDesignStore.newLandLevelingResults?.totalBufferFill
                ? toDecimalPrecision(landLevelingDesignStore.newLandLevelingResults?.totalBufferFill, 2)
                : '--'}{' '}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-1">
              Buffer Area (acre):{' '}
              {landLevelingDesignStore.newLandLevelingResults?.bufferArea
                ? toDecimalPrecision(landLevelingDesignStore.newLandLevelingResults?.bufferArea, 2)
                : '--'}
            </div>
          </div>
        </div>
      </div>


      <div className="row justify-content-end bottom-sections">
        <div className="bottom-buttons">
          <button
            hidden={!landLevelingDesignStore.editDesign}
            className="usa-button float-right"
            onClick={() => {
              vm.postUpdateDesignElement(props.mapView);
            }}
            disabled={
              //disable the form when form's numeric fields are updated after design
              //disable the save button when name field is empty
              !landLevelingDesignStore.newDesignForm.name ||
              (!landLevelingDesignStore.newDesign && !landLevelingDesignStore.pendingEdits.name && !landLevelingDesignStore.pendingEdits.design) || landLevelingDesignStore.pendingEdits.design
            }
          >
            Accept Edits
          </button>
          <button
            hidden={landLevelingDesignStore.editDesign}
            className="usa-button float-right"
            onClick={() => {
              vm.postAddDesignElement(props.mapView);
            }}
            disabled={
              //disable the save button when name field is empty
              !landLevelingDesignStore.newDesignForm.name ||
              !landLevelingDesignStore.newLandLevelingResults?.modifiedPlanePoints ||//disable the form when form's numeric fields are updated after design
              (!landLevelingDesignStore.newDesign && !landLevelingDesignStore.pendingEdits.name && !landLevelingDesignStore.pendingEdits.design) || landLevelingDesignStore.pendingEdits.design
            }
          >
            Save Structure
          </button>
          <button
            className="usa-button usa-button--outline float-right"
            onClick={() => {
              vm.cancelAddDesignElement(props.mapView, true);
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export const NewLandLeveling = observer(NewLandLevelingComponent);
